import React, { useEffect, useState } from "react";
import {
  CancelButton,
  DeleteButton,
  EditButton,
  SafeInput,
  SaveButton,
  TableCell,
  TableRow,
} from "../styles";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

export const InvalidRowContact = ({ index, style, data }) => {
  const { items, onEdit, editingId, setEditingId, onDelete, defaultVariables } =
    data;
  const item = items && items[index];

  // Default object
  const safeItem = item || { phone: "", data: [], reason: "", row: "" };

  const isEditing = editingId === `INVALID-${index}`;

  // item.data es el array raw [telefono, var1, var2...]
  const varsRaw = safeItem.data ? safeItem.data.slice(1) : [];

  // Local state para edición temporal - HOOKS UNCONDITIONAL
  const [tempPhone, setTempPhone] = useState(safeItem.phone);
  const [tempVars, setTempVars] = useState([...varsRaw]);

  useEffect(() => {
    if (isEditing) {
      setTempPhone(safeItem.phone);
      setTempVars(safeItem.data ? safeItem.data.slice(1) : []);
    }
  }, [isEditing, safeItem]); // Use safeItem

  if (!item) {
    return <div style={style}>Cargando...</div>;
  }

  const handleSave = () => {
    if (tempPhone !== item.phone) {
      onEdit(index, "INVALID", "phone", tempPhone);
    }

    tempVars.forEach((val, idx) => {
      // Check if changed (simple string comparison)
      // La raw data original puede ser undefined en esa pos
      const original = varsRaw[idx];
      if (val !== original) {
        onEdit(index, "INVALID", `var${idx + 1}`, val);
      }
    });

    setEditingId(null);
  };

  // Rellenar visualmente variables si faltan en raw data para que cuadre con columnas
  const displayVars = [...tempVars];
  if (defaultVariables && defaultVariables.length > displayVars.length) {
    for (let i = displayVars.length; i < defaultVariables.length; i++) {
      displayVars.push("");
    }
  }

  return (
    <TableRow style={style}>
      <TableCell flex={0.5}>#{item.row}</TableCell>

      <TableCell flex={1.5}>
        {isEditing ? (
          <SafeInput
            value={tempPhone}
            onChange={(e) => setTempPhone(e.target.value)}
            style={{ color: "#d32f2f" }}
          />
        ) : (
          <span style={{ color: "#d32f2f" }}>{item.phone || "Vacío"}</span>
        )}
      </TableCell>

      <TableCell flex={2} error>
        {item.reason}
      </TableCell>
      {/* Dynamic Columns for Variables */}
      {defaultVariables.map((_, vIndex) => (
        <TableCell key={vIndex} flex={1}>
          {isEditing ? (
            <SafeInput
              value={displayVars[vIndex] || ""}
              onChange={(e) => {
                const newVars = [...displayVars];
                newVars[vIndex] = e.target.value;
                setTempVars(newVars);
              }}
            />
          ) : (
            <span style={{ color: "#9ca3af" }}>{varsRaw[vIndex] || "-"}</span>
          )}
        </TableCell>
      ))}

      <TableCell
        style={{
          display: "flex",
          gap: "0.5rem",
          justifyContent: "flex-end",
          flex: "0 0 auto",
          overflow: "visible",
          minWidth: isEditing ? "140px" : "60px",
        }}
      >
        {isEditing ? (
          <>
            <SaveButton onClick={handleSave}>Guardar</SaveButton>

            <CancelButton onClick={() => setEditingId(null)}>
              Cancelar
            </CancelButton>
          </>
        ) : (
          <>
            <EditButton
              onClick={() => setEditingId(`INVALID-${index}`)}
              title="Editar"
            >
              <FaRegEdit />
            </EditButton>

            <DeleteButton
              onClick={() => onDelete(index, "INVALID")}
              title="Eliminar"
            >
              <FaRegTrashAlt />
            </DeleteButton>
          </>
        )}
      </TableCell>
    </TableRow>
  );
};
